
import { defineComponent } from 'vue'

import useTooltip from '@/common/composable/useTooltip'

export default defineComponent({
    props: {
        paymentMethod: {
            type: Number,
            default: null
        }
    },
    setup(props) {
        const { reference, tooltip, isVisible, x, y, strategy, open, close } = useTooltip({
            placement: 'bottom',
            strategy: 'absolute',
            offset: 16,
            autoPlacement: {
                allowedPlacements: ['bottom', 'top'],
            },
        })

        return {
            reference,
            tooltip,
            isVisible,
            x,
            y,
            strategy,
            open,
            close,
        }
    }
})
